/**
 * Standalone Task Manager feature.
 *
 * This folder is intentionally self-contained so the Task Manager UI can evolve
 * independently of the rest of the app. The page renders inside the existing
 * app chrome (shared TopNav + side nav); we only own the route content here.
 *
 * The page content (Workflow Overview cards, categories, etc.) is populated from
 * a backend API that is not integrated yet and will be built out later.
 */

export const TASK_MANAGER_ROUTE = "/taskmanager";
export const TASK_MANAGER_NAV_LABEL = "Task Management";
export const getTaskManagerAuditRoute = (dashboardId) =>
  `${TASK_MANAGER_ROUTE}/${dashboardId}/audit-logs`;

/* ---- Task Manager tabs embedded on the app details page ----
 * The app details page renders one tab per Task Manager dashboard associated
 * with the app. Those tab ids are dynamic (they carry the dashboard id), so
 * they are built from — and parsed back with — this shared prefix instead of
 * living in the static main-tab id list. */

export const TASK_MANAGER_TAB_ID_PREFIX = "taskmanager-";

export const getTaskManagerTabId = (dashboardId) =>
  `${TASK_MANAGER_TAB_ID_PREFIX}${dashboardId}`;

export const isTaskManagerTabId = (tabId) =>
  typeof tabId === "string" && tabId.startsWith(TASK_MANAGER_TAB_ID_PREFIX);

// The dashboard id a task-manager tab id points at, or null for any other tab.
export const getDashboardIdFromTabId = (tabId) =>
  isTaskManagerTabId(tabId) ? tabId.slice(TASK_MANAGER_TAB_ID_PREFIX.length) : null;
